import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { HttphelperService } from 'src/app/core/services/helpers/httphelper.service';
import { ILogin } from 'src/app/models/ILogin';
import { IPatIdRegisteration } from 'src/app/models/IPatIdRegisteration';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pat-code-registeration',
  templateUrl: './pat-code-registeration.component.html',
  styleUrls: ['./pat-code-registeration.component.scss']
})
export class PatCodeRegisterationComponent implements OnInit {
  userName:string = "";
  password:string = "";
  confirmPassword:string = "";
  patId:string=""; 
  forget:boolean=false;
  loading=false;
  verificationMethod:string="";
  _errorMessage:string=''; 
  inputField:string='';
  hasAccount = false;
  isVerified = false;
  encPatId:string;
  get errorMessage():string
  {
    return this._errorMessage;
  }
  set errorMessage(value:string)
  {
   this._errorMessage = value;
   this.messageService.add({severity: 'error', summary: 'Error', detail:this._errorMessage, life: 2000});
  }

  constructor(private activatedRoute: ActivatedRoute,private router:Router, private httphelper:HttphelperService,private route : ActivatedRoute,private messageService:MessageService) { 
    this.activatedRoute.queryParams.subscribe(params => {
      let result = params['EncPatId'] || params['encpatid'];
      this.encPatId = result;
    });
  }
 
  ngOnInit(): void {
    this.hasAccount = false;
    this.isVerified = false; 
    
    var url = "/api/Account/PortalAuth?EncPatId="+this.encPatId;
    this.loading = true;
    this.httphelper.getRequest(url,false).subscribe({
      next: res => {
        if(res.Success)
          {
            this.userName = res.Data.UserName;
            this.verificationMethod = res.Data.VerificationMethod;        
            this.patId = res.Data.PatId;
            this.hasAccount = res.Data.HasAccount;
          }
          else
          {           
            //localStorage.clear();
            this.errorMessage = res.Message;
            setTimeout(() => {
            window.location.href = 'history';

            }, 2000);            
            
            // this.router.navigate(['/history']).then(() => {
            //   debugger;
            //   //this.messageService.add({severity: 'error', summary: 'Error', detail:res.mes, life: 2000});
            // });
          }
          this.loading = false;
        },
        error:err => {this.errorMessage = "Error While Processing Data"     ;this.loading = false;}
      });
  }
  forgetPassword():void{
    this.forget = true;
  }
  SubmitReg():void
  {
    if(this.password == "" || this.password == undefined)
    {
      this.messageService.add({severity: 'warn', summary: 'Warning', detail:"Please Enter Password", life: 2000});
      //this.alert.warn("Please Enter New Password");
      return;
    }
    if(this.confirmPassword == "" || this.confirmPassword == undefined)
    {
      this.messageService.add({severity: 'warn', summary: 'Warning', detail:"Please Enter Confirm Password", life: 2000});
      //this.alert.warn("Please Enter Confirm Password");
      return;
    }
    if(this.password != this.confirmPassword)
    {
      this.messageService.add({severity: 'warn', summary: 'Warning', detail:"Confirm Password Doesn't Match  Password", life: 2000});
      //this.alert.warn("Confirm Password Doesn't Match New Password");
      return;
    }
    var url = "/api/Account/RegisterPortslAuth";
    var model : IPatIdRegisteration = {PatId : this.patId , Type : this.verificationMethod , UserInput : this.inputField , UserName : this.userName,Password:this.password };
    this.loading = true;
    this.httphelper.postRequest(url,false,model).subscribe(
      {
        next:data => {
          if(data.Success)
          {
            if(data.Data.token == null || data.Data.token == undefined)
            {
              this.errorMessage = "This User Is Not Active";
               return;
            }
            localStorage.clear();
            localStorage.setItem('token',data.Data.token);
            localStorage.setItem('patientName',data.Data.FullName);
            localStorage.setItem('gender',data.Data.GenderId);
            localStorage.setItem('PatientId',data.Data.PatientId);
            localStorage.setItem('Image',data.Data.Image);
            localStorage.setItem('lang',"en");
            if(data.Data.LanguageId == 1){
             localStorage.setItem('lang',"ar");
            }
            window.location.href = 'history';
            //this.loading = false;
          }
          else
          {
             this.errorMessage = data.Message;
          }
          this.loading = false;
       },
       error:err => {this.errorMessage = "Error While Processing Data"     ;this.loading = false;}
      }
    );
  }
  verify():void
  { 
    var url = "/api/Account/VerifyPortalMethod";
    var model : IPatIdRegisteration = {PatId : this.patId , Type : this.verificationMethod , UserInput : this.inputField , UserName : this.userName,Password:this.password};
    this.loading = true;
    this.httphelper.postRequest(url,false,model).subscribe({
      next:res => {
        if(res.Success)
        {          
          debugger;          
          this.userName = res.Data.UserName;
          this.isVerified = true;
          this.messageService.add({severity: 'success', summary: 'Success', detail:res.Message, life: 2000});
        }
        else
        {
           this.errorMessage = res.Message;
        }
        this.loading = false;
      }
      ,error:err=>{this.errorMessage = "Error While Processing Data"     ;this.loading = false;}
    });
  }
  Submit():void
  {
    // Chack in User name and Password
    if(this.userName == "" || this.userName == undefined)
    {
      this.messageService.add({severity: 'warn', summary: 'warning', detail:"Please Enter User Name", life: 2000});
      //this.alert.warn("Please Enter User Name");
      return;
    }
    if(this.password == "" || this.password == undefined)
    {
      this.messageService.add({severity: 'warn', summary: 'warning', detail:"Please Enter Password", life: 2000});
     // this.alert.warn("Please Enter Password");
      return;
    }
    let url = 'api/Account/MobileLogin';
    let model :ILogin  =  {UserName : this.userName , Password : this.password , IsDoctor : false , FirebaseToken:""};
    this.loading = true;
    this.httphelper.postRequest(url,false,model).subscribe(
      {
        next:data => {
           if(data.Success)
           {
             if(data.Data.token == null || data.Data.token == undefined)
             {
               this.errorMessage = "This User Is Not Active";
                return;
             }
             localStorage.setItem('token',data.Data.token);
             localStorage.setItem('patientName',data.Data.FullName);
             localStorage.setItem('gender',data.Data.GenderId);
             localStorage.setItem('PatientId',data.Data.PatientId);
             localStorage.setItem('Image',data.Data.Image);
             localStorage.setItem('lang',"en");
             if(data.Data.LanguageId == 1){
              localStorage.setItem('lang',"ar");
             }
             window.location.href = 'history';
            // this.loading = false;
           }
           else
           {
              this.errorMessage = data.Message;
           }
           this.loading = false;
        },
        error:err => {this.errorMessage = "Error While Processing Data"     ;this.loading = false;}
      }
    );
   }
}

